<div class="menu-area">
    <div class="container">
        <div class="row align-items-center position-relative">
            <div class="col-lg-3 hamburger-menu position-relative">
                <div class="menu-logo-wrap">
                    <a href="index.html"><img src="assets/images/logo.svg" alt=""></a>
                </div>
            </div>
            <div class="col-lg-9">
                <div class="nav-wrap d-flex justify-content-between align-items-center">
                    <div class="mainmenu text-right">
                        <ul class="home-menu">                    
                           
                        </ul>
                        <div class="menu-btn-wrap flex-shrink-0 d-lg-none pb-5 pt-3 ps-4">
                            <a class="common-btn bg-white-style me-2" href="sign-up.html">Sign Up </a>
                            <a class="common-btn border-style border-style-transparent" href="login.html">Login</a>
                        </div>
                    </div>
                    <div class="menu-btn-wrap flex-shrink-0 d-none d-lg-block">
                        <a class="common-btn bg-white-style me-2" href="sign-up.html">Sign Up </a>
                        <a class="common-btn border-style border-style-transparent" href="login.html">Login</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>